"use strict";
/* globals module */
/**
 * @module articleTagsRoute
 * @description Baasic Article Tags Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var _1 = require("./");
var ArticleTagsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleTagsRoute, _super);
    function ArticleTagsRoute(articleTagsSubscriptionsRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleTagsSubscriptionsRoute = articleTagsSubscriptionsRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'article-tags/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'article-tags/{id}/{?embed,fields}';
        _this.updateRoute = 'article-tags/{id}';
        _this.deleteRoute = 'article-tags/{id}';
        return _this;
    }
    Object.defineProperty(ArticleTagsRoute.prototype, "subscriptions", {
        get: function () {
            return this.articleTagsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find article tags route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article tags using the phrase search; multiple tag keywords must be comma separated.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article tag subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article tag property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example articleTagsRoute.find().expand({searchQuery: '<search-phrase>'});
     **/
    ArticleTagsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Article tag id or slug that uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleTagsRoute.get({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag object used to update specified article tag resource.
     * @example articleTagsRoute.update({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag object used to delete specified article tag resource.
     * @example articleTagsRoute.delete({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    ArticleTagsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsSubscriptionsRoute !== "undefined" && _1.ArticleTagsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], ArticleTagsRoute);
    return ArticleTagsRoute;
}(common_1.BaseRoute));
exports.ArticleTagsRoute = ArticleTagsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 
